<script setup lang="ts">
const websiteInfo = useWebsiteInfoStore()
// Fetch website information from the store
const logo = computed(() => websiteInfo?.logo?.large || '')
const websiteName = computed(() => websiteInfo?.name || 'Your Website')
const websiteDescription = computed(() => websiteInfo?.description || '')
</script>

<template>
  <div>
    <!-- Logo -->
    <div class="tw-mb-6 md:tw-mb-4">
      <LinkLocale
        to="/"
        :title="websiteName"
        class="tw-inline-block tw-w-full"
      >
        <MediaImageLazyLoad
          :src="logo"
          class="tw-footer-logo"
          :alt="websiteName"
          width="50%"
          height="40px"
          fit="contain"
          position="0"
        />
      </LinkLocale>
    </div>

    <!-- Description -->
    <ul
      class="web-description tw-text-mb-body-small lg:tw-text-dt-body-small tw-space-y-2"
    >
      <li>{{ websiteDescription }}</li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.footer-widget {
  @apply tw-space-y-4;
}
</style>
